var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupSplashPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sup_splash_placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.28,182.11,172.91,202l18.21-3.31-11.59-13.25s14.91-1.65,31.47-13.25H174.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.72,182.11,143.09,202l-18.22-3.31,11.6-13.25s-14.91-1.65-31.47-13.25h36.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "161.31 185.42 158 187.08 154.69 185.42 143.09 233.45 158 243.39 172.91 233.45 161.31 185.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "141.44 160.58 158 182.11 174.56 160.58 169.59 155.61 146.41 155.61 141.44 160.58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupSplashPlaceholder);
export default __webpack_public_path__ + "static/media/sup_splash_placeholder.4b7c3bd9aa99bee2feea8ee4d5a53bc9.svg";
export { ForwardRef as ReactComponent };